export const updateDataLayer = (nbHits, searchTerm) => {
	if (window.dataLayer[0].navigation) {
		const { navigation } = window.dataLayer[0];
		navigation.searchResultCount = nbHits;
		navigation.searchTerms = searchTerm;
	}
};
